<template>
  <div class="topman">
      <div class="top-layout">
      <div class="item-layout">
        <div class="item-content">
          <div class="left">
            <img src="@/assets/home/icon1.png" />
            <div>{{ $t('home.name39') }}</div>
          </div>
          <!-- <div class="right" @click="jumpPath('manufacturerslist',4)">
            <div>{{ $t('home.name1') }}</div>
            <img src="@/assets/home/right-icon.png" />
          </div> -->
        </div>
        <div class="hs">
          <div>{{ cssl }}</div>
          <div></div>
        </div>
      </div>
      <div class="zw"></div>
      <div class="item-layout">
        <div class="item-content">
          <div class="left">
            <img class="img2" src="@/assets/home/icon2.png" />
            <div>{{ $t('home.name40') }}</div>
          </div>
          <!-- <div class="right" @click="jumpPath('merchantlist',4)">
            <div>{{ $t('home.name1') }}</div>
            <img src="@/assets/home/right-icon.png" />
          </div> -->
        </div>
        <div class="hs">
          <div>{{ iotshsl }}</div>
          <div></div>
        </div>
      </div>
      <div class="zw"></div>
      <div class="item-layout">
        <div class="item-content">
          <div class="left">
            <img class="img2" src="@/assets/home/icon3.png" />
            <div>{{ $t('home.name41') }}</div>
          </div>
          <!-- <div class="right" @click="jumpPath('bikelist',1)">
            <div>{{ $t('home.name1') }}</div>
            <img src="@/assets/home/right-icon.png" />
          </div> -->
        </div>
        <div class="hs">
          <div>{{ shsl }}</div>
          <div></div>
        </div>
      </div>
      <div class="zw"></div>
      <div class="item-layout">
        <div class="item-content">
          <div class="left">
            <img class="img2" src="@/assets/home/icon4.png" />
            <div>{{ $t('home.name42') }}</div>
          </div>
          <!-- <div class="right" @click="jumpPath('iotcharging',2)">
            <div>{{ $t('home.name1') }}</div>
            <img src="@/assets/home/right-icon.png" />
          </div> -->
        </div>
        <div class="hs">
          <div>{{ ljsf }}</div>
          <div></div>
        </div>
      </div>
    </div>
    <el-form :model="queryInfo" size="medium" :label-width="formLabelWidth('xs')" :inline="true" style="margin-top:30px;">
            <el-form-item :label="$t('login.name20')" prop="keyword">
              <el-input v-model="queryInfo.keyword" :placeholder="$t('public.name5')" clearable> </el-input>
            </el-form-item>
            <el-form-item :label="$t('manage.name58')" prop="searchTime">
              <el-date-picker
            v-model="queryInfo.searchTime"
            type="datetimerange"
           value-format="yyyy-MM-dd HH:mm:ss"
            :range-separator="$t('public.name9')"
            :start-placeholder="$t('public.name10')"
            :end-placeholder="$t('public.name11')"
          >
          </el-date-picker>
            </el-form-item>
            <el-form-item >
              <el-button type="primary" size="medium" @click="queryList">{{ $t('public.name3') }}</el-button>
          <el-button size="medium" @click="resetQuery">{{ $t('public.name4') }}</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="tableList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading="tableLoading">
      <el-table-column :label="$t('operate.name45')" prop="userId" sortable></el-table-column>
      <el-table-column :label="$t('login.name16')" prop="loginName" sortable></el-table-column>
      <el-table-column :label="$t('tabmenu.name2')" prop="ebikeId" sortable></el-table-column>
      <el-table-column :label="$t('public.name51')" prop="loginDate" sortable>
        <template slot-scope="scope">
          {{ scope.row.loginDate | tzDisplay }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('operate.name166')" prop="travelEdit" sortable></el-table-column>
      <el-table-column :label="$t('operate.name167')" prop="travelUse" sortable></el-table-column>
      <el-table-column :label="$t('operate.name168')" prop="rideMode" sortable></el-table-column>
      <el-table-column :label="$t('operate.name169')" prop="findCar" sortable></el-table-column>
      <el-table-column :label="$t('operate.name170')" prop="alarmSet"></el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="queryInfo.limit"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </div>
</template>
<script>
import { numberExchange } from '@/utils/utils.js'
import { saleFirstLine, appUserPage } from '@/api/home.js'
export default {
  data() {
    return {
      cssl: 0,
      iotshsl: 0,
      shsl: 0,
      ljsf: 0,
      total: 0,
      tableList: [],
      tableLoading: false,
      queryInfo: {
        keyword: '',
        startTime: '',
        endTime: '',
        searchTime: [],
        limit: 10,
        page: 1
      }
    }
  },
  created() {
  },
  mounted() {
    this.getTopData()
    this.queryList()
  },
  methods: {
    getTopData() {
      saleFirstLine()
        .then((res) => {
          this.cssl = numberExchange(res.data.userNum) || 0
          this.iotshsl = numberExchange(res.data.onlineNum) || 0
          this.shsl = numberExchange(res.data.offlineNum) || 0
          this.ljsf = numberExchange(res.data.newUserNum) || 0
        })
        .catch(() => {})
    },
    resetQuery() {
      this.queryInfo = {
        keyword: '',
        startTime: '',
        endTime: '',
        searchTime: [],
        limit: 10,
        page: 1
      }
      this.queryList()
    },
    queryList() {
      this.tableLoading = true
      const data = {
        limit: this.queryInfo.limit,
        page: this.queryInfo.page
      }
      if (this.queryInfo.keyword) {
        data.keyword = this.queryInfo.keyword
      }
      if (this.queryInfo.searchTime) {
        const { startTime, endTime } = this.$tz.rangeToAccountQuery(this.queryInfo.searchTime)
        data.startTime = startTime
        data.endTime = endTime
      }
      appUserPage(data)
        .then((res) => {
          this.tableList = res.data.list
          this.total = res.data.total
          this.tableLoading = false
        })
        .catch(() => {
          this.tableLoading = false
        })
    },
    handleSizeChange(newSize) {
      this.queryInfo.limit = newSize
      this.queryList()
    },
    handleCurrentChange(newPage) {
      this.queryInfo.page = newPage
      this.queryList()
    }
  }
}
</script>

<style lang="scss">
.el-tabs__item {
  padding: 0px 10px;
  cursor: pointer;
}
.el-tabs__nav-wrap::after {
  height: 0px;
}

.el-tabs__item:hover {
  color: #0f73e6;
}
.el-tabs__item.is-active {
  color: #0f73e6;
}

.el-tabs__active-bar {
  background-color: #0f73e6;
}
</style>
<style lang="scss" scoped>
.topman {
  .el-tabs {
    position: fixed;
    right: 30px;
    top: 70px;
    z-index: 1999;
  }
  .top-layout {
    display: flex;
    justify-content: space-between;
    // flex-direction: row;
    align-items: center;
    min-width: 1200px;
    .zw {
      width: 1.11vw;
      min-width: 20px;
    }

    .item-layout {
      width: px2vw(320.5);
      height: px2vw(153);
      min-width: 260.5px;
      min-height: 153px;
      border-radius: px2vw(8);
      background: #f5f5f5;
      border: 1px solid #969797;

      .hs {
        display: flex;
        flex-direction: row;
        align-items: baseline;
        margin-left: px2vw(22);
        > :first-child {
          font-family: PuHuiTi-700;
          font-size: 48px;
          line-height: 65.86px;
          text-align: left;
          color: #555555;
        }
        > :last-child {
          font-family: PingFang SC;
          font-size: 14px;
          font-weight: 400;
          line-height: 19.6px;
          margin-left: px2vw(8);
          color: #555555;
        }
      }
      .item-content {
        display: flex;
        justify-content: space-between;
        width: 100%;
        padding: px2vw(20);

        .left {
          display: flex;
          flex-direction: row;
          align-items: center;
          img {
            width: 24px;
            height: 24px;
          }
          .img2 {
            width: 16px;
            height: 16px;
          }
          div {
            font-family: PingFang SC;
            font-size: 14px;
            font-weight: 400;
            line-height: 14px;
            color: #555555;
            margin-left: px2vw(8);
          }
        }

        .right {
          display: flex;
          flex-direction: row;
          align-items: center;
          cursor: pointer;
          img {
            width: 16px;
            height: 16px;
            margin-left: px2vw(4);
          }
          div {
            font-family: PingFang SC;
            font-size: 14px;
            font-weight: 400;
            line-height: 14px;
            color: #8d96a9;
          }
        }
      }
    }
  }

  .gzqk-gzclqk {
    display: flex;
    justify-content: space-between;
    background: #f5f5f5;
    width: 100%;
    height: px2vw(360);
    min-width: 1200px;
    min-height: 360px;
    border-radius: px2vw(8);
    border: 1px;
    margin-top: px2vw(20);

    .lines {
      width: 1px;
      background: #e5e3ec;
      height: px2vw(360);
      min-height: 360px;
      min-width: 1px;
    }
    .gzqk {
      width: 100%;
      position: relative;
    }

    .gzclqk {
      width: 100%;
      display: none;
      position: relative;
    }
  }

  .xzqs {
    display: flex;
    background: #f5f5f5;
    width: 100%;
    min-width: 1200px;
    min-height: 360px;
    height: px2vw(360);
    border-radius: px2vw(8);
    border: 1px;
    margin-top: px2vw(20);
    position: relative;
    z-index: 9;
  }

  .simksyqk {
    display: flex;
    background: #f5f5f5;
    width: 100%;
    height: px2vw(360);
    min-width: 1200px;
    min-height: 360px;
    border-radius: px2vw(8);
    border: 1px;
    margin-top: px2vw(20);
    position: relative;
    z-index: 9;
  }

  .text-select {
    display: flex;
    position: absolute;
    left: 0;
    top: 22px;
    justify-content: space-between;
    align-items: center;
    z-index: 10;
    width: 100%;
    padding-left: 20px;
    padding-right: 20px;
    .text {
      font-family: PingFang SC;
      font-size: 16px;
      font-weight: 500;
      line-height: 22.4px;
      color: #0c2358;
    }
  }

  .margin-left10 {
    margin-left: 10px;
  }

  .select-width {
    width: 160px;
  }

  .echarts-div {
    width: 100%;
    height: 100%;
  }

  *,
  :after,
  :before {
    box-sizing: border-box;
  }
}
</style>
